class CartSelectedCollection extends HTMLElement {

	constructor(){
		super();
		this.refreshCollection();
	}

	refreshCollection(){
		fetch(`${window.location.pathname}?section_id=cart-selected-collection`)
			.then(response => response.text())
			.then(text => {
				const innerHTML = new DOMParser()
					.parseFromString(text, 'text/html')
					.querySelector('[data-js-cart-selected-collection]');
				if ( innerHTML && innerHTML.querySelectorAll('[data-js-product-item]').length > 0 ) {
					this.innerHTML = innerHTML.outerHTML;
					// Reset slider after content update
					const slider = this.querySelector('css-slider');
					if ( slider && slider.resetSlider ) {
						slider.resetSlider();
					}
				} else {
					// No products to show, hide the component
					this.innerHTML = '';
				}
			})
	}
}

// Listen for cart updates to refresh the collection
document.addEventListener('cart:updated', () => {
	const selectedCollection = document.querySelector('cart-selected-collection');
	if ( selectedCollection ) {
		selectedCollection.refreshCollection();
	}
});

customElements.define('cart-selected-collection', CartSelectedCollection);
